// Landing copy — carried over from `b00k-landing.dc.html` verbatim.

import type { Dict } from "./pl.js";

export const en: Dict = {
  navCats: "Categories",
  navHow: "How it works",
  navOps: "For operators",
  navPrice: "Pricing",
  navContact: "Contact",
  navBook: "Operator panel demo",
  pill: "The booking platform for service operators",
  title1: "Your services.",
  title2: "Book themselves.",
  sub: "b00k merges all your service calendars — rooms, cars, appointments — into one booking system. Clients book by web and chat while the system guards the schedule and blocks conflicts.",
  ctaBook: "Create operator account",
  ctaOperator: "See the customer view",
  heroMeta: "YOUR-COMPANY.B00K.ONLINE · EVERY OPERATOR GETS THEIR OWN SUBDOMAIN",
  cardChip: "Confirmed",
  cardNote: "Bookings flow in by themselves — from web and chat — and lock the schedule instantly.",
  catsKick: "SERVICE CATEGORIES",
  catsTitle: "What you can run on b00k",
  catsSub: "One platform for all your services. Timed ones run back-to-back; rooms and cars are booked in parallel for days.",
  cat1t: "Rooms",
  cat1d: "Rooms and apartments for one or many nights. Several rooms book in parallel for the same dates.",
  cat2t: "Cars",
  cat2d: "City cars and SUVs by the day. The availability calendar guards pickups and returns.",
  cat3t: "Attractions",
  cat3d: "Sauna, spa, kayaks. Booked for a specific hour with a fixed duration.",
  cat4t: "Hairdresser",
  cat4d: "Cuts and coloring. Pick an hour — the system blocks exactly as long as the service takes.",
  cat5t: "Beauty",
  cat5d: "Manicure and massage. Combine with other services — durations merge into one block.",
  cat6t: "Medical",
  cat6d: "Consultations and exams at a set hour. The clinic calendar keeps itself in order.",
  cat7t: "Workshop",
  cat7d: "Car, bike or laptop repair — we cover it all.",
  cat8t: "Tutoring",
  cat8d: "Language lessons or piano practice — run it on our platform.",
  cat9t: "Other",
  cat9d: "Your industry's specifics + our experience = success.",
  howKick: "HOW IT WORKS",
  howTitle: "Three steps, zero phone calls",
  s1t: "Add services and resources",
  s1d: "List rooms, cars and appointments with durations and prices. The system validates every account at sign-up — yours and your clients'.",
  s2t: "Clients book themselves",
  s2d: "By web or chat — WhatsApp and Messenger. Durations add up, rooms book in parallel, and clients only see slots that are truly free.",
  s3t: "The system guards the schedule",
  s3d: "On confirmation the slot is locked — two people can never book the same service at the same time. Cancellations and reschedules are handled too.",
  newChip: "New",
  chatLine: "Your clients can book by chatting — via WhatsApp or Messenger.",
  opsKick: "FOR OPERATORS",
  opsTitle: "Your schedule works for you",
  opsSub: "Rooms, cars and appointments in one calendar. Conflicts are blocked automatically, chat bookings flow in by themselves, and you watch occupancy and revenue live.",
  opsCta: "See the operator panel",
  f1: "Day calendar and resource occupancy in one view",
  f2: "Automatic booking-conflict lock",
  f3: "Bookings from web and chat — WhatsApp / Messenger",
  f4: "Clients, booking notes and KPIs",
  priceKick: "PRICING",
  priceTitle: "As simple as a booking",
  month: "mo",
  recommended: "Recommended",
  soon: "AVAILABLE SOON",
  custom: "Custom",
  opsSuffix: "employees",
  priceNote: "The monthly price depends on how many employees have access to the panel.",
  t1f1: "Calendar and online bookings",
  t1f2: "WhatsApp / Messenger chat",
  t1f3: "Clients, notes and reminders",
  t2f1: "Everything in SOLO",
  t2f2: "Unlimited resources and services",
  t2f3: "Reports and occupancy metrics",
  t3f1: "Everything in TEAM",
  t3f2: "Staff schedules and roles",
  t3f3: "API and integrations",
  t4f1: "Everything in GROUP",
  t4f2: "Onboarding support and SLA",
  t4f3: "Individual contract and billing",
  conKick: "CONTACT & DIRECTIONS",
  conTitle: "Your location, their directions",
  dirKick: "DIRECTIONS — AS YOUR CLIENTS SEE THEM",
  dir1: "By car: national road 3 from Jelenia Góra, exit Szklarska Poręba Centrum, then 5 minutes along Zdrojowa street.",
  dir2: "By train: Szklarska Poręba Górna station, a 12-minute walk towards the centre.",
  dir3: "Free on-site guest parking — no charge, no reservation.",
  footUser: "Customer view",
  footOp: "Operator panel",

  wizTitle: "Create operator account",
  wizSub: "Seven steps. You finish with your own subdomain and a ready-to-use panel.",
  wizStep1: "Company",
  wizStep2: "Subdomain",
  wizStep3: "Industries",
  wizStep4: "Plan",
  wizStep5: "Administrator",
  wizStep6: "Payments",
  wizStep7: "Summary",
  wizNext: "Next",
  wizBack: "Back",
  wizFinish: "Create account",
  fCompany: "COMPANY NAME",
  fNip: "VAT ID (NIP)",
  fPhone: "PHONE",
  fAddress: "ADDRESS",
  fSlug: "SUBDOMAIN",
  slugHint: "The address where your clients will book your services.",
  slugChecking: "Checking availability…",
  slugFree: "The subdomain is free.",
  slugTaken: "This subdomain is already taken.",
  slugInvalid: "Subdomain: 3–63 characters, lowercase letters, digits and hyphen (not first or last).",
  industriesHint: "Pick the industries you serve. You can add more later in the panel.",
  planHint: "Change your plan anytime — no data is lost.",
  fName: "FULL NAME",
  fEmail: "E-MAIL",
  fPass: "PASSWORD (MIN. 8 CHARS)",
  fPass2: "REPEAT PASSWORD",
  fTerms: "I accept the b00k.online terms and consent to data processing for booking purposes.",
  payTitle: "Customer payments",
  payHint: "Optional. You can accept online payments when a booking is confirmed.",
  payEnable: "Accept online payments",
  payMethods: "PAYMENT METHODS",
  sumTitle: "Summary",
  sumCompany: "COMPANY",
  sumSub: "SUBDOMAIN",
  sumIndustries: "INDUSTRIES",
  sumPlan: "PLAN",
  sumAdmin: "ADMINISTRATOR",
  sumPayments: "PAYMENTS",
  yes: "Yes",
  no: "No",
  doneTitle: "Operator account is ready",
  doneSub: "Your subdomain is live. Sign in to the panel and add services — bookings start right away.",
  doneOpen: "Open the operator panel",
  doneBooking: "See the booking page",
  companyProofOk: "Signed in as company administrator:",
  companyLoginOther: "Sign in with a different account",
  errGeneric: "We couldn't create the account. Check the data and try again.",
};
